import type { RawParams } from "@uirouter/react";

import Sentry from "@similarweb/sentry-logger";

import type { IRouterState, PageViewTrackingHandler } from "single-spa/react-app/router/IRouterState";
import { SwTrack } from "app/services/SwTrack";

export const marketingChannelsPageViewTracking: PageViewTrackingHandler = async ({ toState, toParams }) => {
    try {
        SwTrack.trackPageView(toState, toParams);
    } catch (e) {
        Sentry.error("marketingChannelsPageViewTracking: unable to track page view", e);
    }
};
